import { useContext } from 'react';
import {
  FlatsTableListContext,
  FlatsTableListActionsContext,
} from './contexts';

export const useFlatsTableList = () => useContext(FlatsTableListContext);
export const useFlatsTableListActions = () =>
  useContext(FlatsTableListActionsContext);
